/* eslint-disable jira/filename-case */
import React, { useContext, createContext, type ReactNode, useEffect, useMemo } from 'react';
import { rootRegistry, ShortcutRegistry } from './shortcut-registry.tsx';

export const ShortcutRegistryContext: React.Context<ShortcutRegistry> =
	createContext<ShortcutRegistry>(rootRegistry);

type Props = {
	children?: ReactNode;
};

const ShortcutScope = ({ children = null }: Props): React.JSX.Element => {
	const registry = useMemo(() => new ShortcutRegistry(), []);
	const parentRegistry = useContext(ShortcutRegistryContext) || rootRegistry;

	useEffect(() => {
		// "This only happens ONCE.  But it happens AFTER the initial render."
		const removeRegistry = parentRegistry.addChildRegistry(registry);
		return removeRegistry;

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ShortcutRegistryContext.Provider value={registry}>{children}</ShortcutRegistryContext.Provider>
	);
};

const ExportedComponent: ({ children }: Props) => React.JSX.Element = __SERVER__
	? ({ children = null }: Props) => <>{children}</>
	: ShortcutScope;
export default ExportedComponent;
